// src/utils/index.ts

import * as utilsFuncs from './utils';

export const utils = {
    ...utilsFuncs
};